import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EUserRole } from 'src/app/domain/enum/user-role';
import { User } from 'src/app/domain/user';
import { SimpleListModel } from 'src/app/model/simple-list.model';
import { CoreData } from '../../core-data/core-data';
import { StringTool } from '../../mapping/string.tool';
import { StringConverter } from '../string-converter';

@Component({
    selector: 'app-user-box',
    templateUrl: './user-box.component.html',
    styleUrls: ['./user-box.component.scss']
})
export class UserBoxComponent implements OnInit, AfterContentInit {
    public ValidEmail = new UntypedFormControl('', Validators.compose([
        Validators.required,
        Validators.pattern(/([a-zA-Z0-9_.+-]+)@([a-zA-Z0-9-\.]+)(\.[a-zA-Z0-9]{2,3})/)]));


    Model: User = new User();
    IsCreation: boolean = true;

    public UserTypeList: SimpleListModel[] = Object.values(EUserRole)
        .filter(x => !isNaN(Number(x)))
        // .map((x) => StringConverter.getUserTypeName(x as EUserRole));
        .map(x => {
            const slm = new SimpleListModel();
            slm.idx = x as number;
            slm.s = StringConverter.getUserTypeName(x as EUserRole);
            return slm;
        });

    constructor(
        public dialogRef: MatDialogRef<UserBoxComponent>,
        public coreData: CoreData,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.Model = Object.assign({}, data);
            this.IsCreation = false;
        }

        if (this.coreData.User)
            if (!(this.coreData.User.CanCreateGestionnaire))
                this.UserTypeList = this.UserTypeList.slice(1);

            
        if (!this.coreData.User)  
        {
            this.UserTypeList = this.UserTypeList.slice(0,1);
            this.Model.Type=   EUserRole.Gestionnaire; 
        } 
            
        
        //this.Model.IsActive = true;
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        this.ValidEmail.markAsTouched();
        if (this.IsCreation) {
            this.Model.IsActive = true;
        }
        else {
            this.ValidEmail.disable();
        }
    }

    CanSave() {
        return StringTool.isNotNullOrEmpty(this.Model.FirstName)
            && StringTool.isNotNullOrEmpty(this.Model.LastName)
            && StringTool.isNotNullOrEmpty(this.Model.Email);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.Model.Email = this.Model.Email.toLowerCase();
        this.dialogRef.close(this.Model);
    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }
}
